// extracted by mini-css-extract-plugin
export default {"module":"Module_module__VRhgk","header":"Module_header__9Qq6L","lessons":"Module_lessons__0M2iS"};